import { render, staticRenderFns } from "./SeatPreview.vue?vue&type=template&id=5827511d&scoped=true&"
import script from "./SeatPreview.vue?vue&type=script&lang=js&"
export * from "./SeatPreview.vue?vue&type=script&lang=js&"
import style0 from "./SeatPreview.vue?vue&type=style&index=0&id=5827511d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5827511d",
  null
  
)

export default component.exports